












































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    Pagination,
  },
})
export default class XitongshujuList extends Vue {
  @Prop()
  private message: any;
  private startTime: any = "";
  private endTime: any = "";
  private searchText: any = "";
  private list: any = [];
  private total: any = 0;
  private currentPage: any = 1;
  private disabledStartDate: any = this.beginDate();
  private disabledEndDate: any = this.endDate();

  @Watch("message", { immediate: true })
  private messageChange(msg) {
    if (msg && msg.total_count) {
      this.total = msg.total_count;
      this.list = JSON.parse(JSON.stringify(msg.report));
    }
  }
  private beginDate() {
    const self = this;
    return {
      disabledDate(time) {
        if (self.endTime) {
          return (
            time.getTime() > new Date(self.endTime).getTime() ||
            time.getTime() > Date.now()
          );
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time) {
        if (self.startTime) {
          return new Date(self.startTime).getTime() > time.getTime();
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  /**
   * @description 查看详情
   */
  private jumpDetail(item) {
    console.log("查看详情");
    console.log(item);
    this.$emit("jumpDetail", item);
  }
  /**
   * @description 切换页码
   */
  private handleCurrentPageChange() {
    console.log("页码改变");
  }
  private search() {
    console.log("搜索");
    console.log(this.searchText);
    console.log(this.startTime);
    console.log(this.endTime);
    if (this.startTime && this.endTime) {
      const time =
        new Date(this.endTime).getTime() - new Date(this.startTime).getTime();
      if (time < 0) {
        this.$message.warning("结束时间必须大于开始时间");
        return;
      } else if (time < 1) {
        this.$message.warning("结束时间与开始时间间隔必须大于1秒");
        return;
      }
    }
    const data = {
      startTime: this.startTime,
      endTime: this.endTime,
      searchText: this.searchText,
    };
    this.$emit("searchList", data);
  }
}
